// Images
import Clement from "../../resources/images/team/clem.JPG";
import Freddy from "../../resources/images/team/freddy-janssens.png";

export const TEAM = [
  {
    picture: Freddy,
    name: "Freddy",
    status: "Architecte de Solution IT & Responsable pédagogique",
    description: [
      "✨ Expert certifié Microsoft et VMware",
      "👨🏼‍💻 6 ans d'expérience en formation à distance",
      "🗣 Mentor Cloud auprès de OpenClassRoom",
      "🧠 7 ans d'expérience dans les neurosciences et la neuropédagogie",
      "👨🏼‍🏫 30 ans d'expérience en tant que formateur",
      "🏅 Marathonien, Triathlète IRONMAN (🏊🏻 3,8km, 🚴🏻‍♂️ 180km, 🏃 42km)",
    ],
    linkedin: "https://www.linkedin.com/in/freddy-janssens/",
    style: {
      background:
        "linear-gradient(125deg, rgba(47,234,168,0.1) 0%, rgba(2,140,243,0.1) 100%)",
    },
  },
  {
    picture: Clement,
    name: "Clément",
    status: "Développeur Full Stack",
    description: [
      "✨ 6 ans d'expériences",
      "👨🏼‍💻 Développeur Full Stack en startup & scaleup",
      "🏅 Amateur de musique et de cinéma",
    ],
    style: {
      background:
        "linear-gradient(125deg, rgba(251,171,126,0.1) 0%, rgba(247,206,104,0.1) 100%)",
    },
  },
];
